import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, HeroContent, HeroOverviewContainer, HeroSectionContainer } from './heroSection.styled';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

const HeroSection = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <HeroSectionContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-partners-app-ipad-iphone.png`}
        alt="Pata booking platform shown on iPad and iPhone — manage bookings, clients, and payments in one place"
        height={2000}
        width={2000}
      />

      <WidthContainer noBackground>
        <HeroOverviewContainer>
          <HeroContent>
            <TextWithHighlight>
              <h1>
                Booking software made with your <span>pet care business </span>
                <br />
                in mind
                {/* Your trusted subscription-free <span>booking platform </span>
                for pet care businesses */}
              </h1>
            </TextWithHighlight>
            <p>
              Save time, reduce no-shows and take payments with a subscription-free platform built for UK pet care
              businesses.
              <br />
            </p>
            {/* <p>
              <strong>Sign up for free </strong>
              to transform your pet care business today.
            </p> */}

            <ActionContainer>
              <Button onClick={handleSignUpClick}>Sign up for free</Button>
              <Button buttonType="secondary" onClick={handleBookDemo}>
                Book a demo
              </Button>
            </ActionContainer>
          </HeroContent>
          <Image
            src={`${VITE_CDN_BASE_URL}/images/image-phone-laptop-app.webp`}
            alt="Pata booking platform shown on iPad and iPhone — manage bookings, clients, and payments in one place"
            height={2000}
            width={2000}
          />
        </HeroOverviewContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
